/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Hint_TipInputs */

const en_paste_hint_tip = /** @type {(inputs: Paste_Hint_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip:`)
};

const nl_paste_hint_tip = /** @type {(inputs: Paste_Hint_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tip:`)
};

/**
* | output |
* | --- |
* | "Tip:" |
*
* @param {Paste_Hint_TipInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const paste_hint_tip = /** @type {((inputs?: Paste_Hint_TipInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Hint_TipInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_paste_hint_tip(inputs)
	return en_paste_hint_tip(inputs)
});